import { render, staticRenderFns } from "./logPopup.vue?vue&type=template&id=b04f24c0&"
import script from "./logPopup.vue?vue&type=script&lang=js&"
export * from "./logPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports